import React__default from 'react';
import PropTypes from 'prop-types';

var propTypes = {
  iconName: PropTypes.string,
  labelText: PropTypes.string
};
function PaymentIcon(_ref) {
  var labelText = _ref.labelText,
    _ref$iconName = _ref.iconName,
    iconName = _ref$iconName === void 0 ? 'default-card' : _ref$iconName;
  return /*#__PURE__*/React__default.createElement("span", {
    "aria-hidden": !labelText,
    "aria-label": labelText || null,
    className: "payment-icon",
    "data-icon-name": iconName,
    role: "img"
  });
}
PaymentIcon.propTypes = propTypes;

export { PaymentIcon as default };
//# sourceMappingURL=PaymentIcon.js.map
